import { getRegisterFunction } from '../../utils/register.js';
import { OneUxCardElement } from './OneUxCardElement.js';
export const register = getRegisterFunction(OneUxCardElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-card': OneUxCardElement;
    "card-088600f690734842cac5d3df15bd2f47": OneUxCardElement;
  }
}